/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module cloud-services
 */

export { default as CloudServices } from './cloudservices';
export { default as CloudServicesCore } from './cloudservicescore';
